/**
 * Copyright (C) 2026 Jugendstil, SLU - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited. Proprietary and confidential.
 */

/**
 * The nav bar's leading menu.
 *
 * Script flips one attribute and nothing else: the panel's open and closed states are both in
 * CSS, so the transition, the reduced-motion opt-out and the focus behaviour are all declarative
 * and none of them can drift from what the stylesheet says.
 */
export function setFlyout(open: boolean): void {
    const flyout = document.querySelector<HTMLElement>('[data-wp-flyout]');
    if (flyout === null) {
        return;
    }

    flyout.dataset.open = String(open);

    const scrim = document.querySelector<HTMLElement>('[data-wp-flyout-scrim]');
    if (scrim !== null) {
        scrim.dataset.open = String(open);
    }

    document.querySelectorAll('[data-wp-flyout-toggle]').forEach((toggle) => {
        toggle.setAttribute('aria-expanded', String(open));
    });

    /* The page behind must not scroll while a full-height panel is over it, or dismissing the
       menu leaves you somewhere you did not navigate to. */
    document.body.style.overflow = open ? 'hidden' : '';

    if (open) {
        flyout.querySelector<HTMLElement>('a, button')?.focus();
    }
}

/** Whether the panel is currently open, read from the element rather than held here. */
export function isFlyoutOpen(): boolean {
    return document.querySelector<HTMLElement>('[data-wp-flyout]')?.dataset.open === 'true';
}

export function listen(): void {
    document.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) {
            return;
        }

        if (target.closest('[data-wp-flyout-toggle]') !== null) {
            event.preventDefault();
            setFlyout(!isFlyoutOpen());
        } else if (target.closest('[data-wp-flyout-scrim]') !== null) {
            setFlyout(false);
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            setFlyout(false);
        }
    });
}
